import { render, staticRenderFns } from "./saleAdmin.vue?vue&type=template&id=10cd9f70&"
import script from "./saleAdmin.vue?vue&type=script&lang=js&"
export * from "./saleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./saleAdmin.vue?vue&type=style&index=0&id=10cd9f70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports